import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Tooltip } from "primereact/tooltip";

import { Button, DropDownField, TextAreaField, TextInputField } from "../../../../helpers"

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";

import { calculateSellerPO, getProductName, getProductSpecification, round } from "../../../../utils"
import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";


const DisplaySellerPOItem = (props) => {
    const { materialDetails, displaySellerPOItem, allDisplaySellerPOItems, setDisplaySellerPOItems, relatedSellerCompanyDetails, displaySellerPO, buyerQuoteItems, sellerReqItem } = props

    const brandData = useSelector((state) => state.common.materialBrands)

    const dispatch = useDispatch()

    const pmCompanyConfig = getPMCompanyConfig(displaySellerPO.pmCompanyId)
   
    let gstRates = pmCompanyConfig.GSTRates
    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), value: eachGSTRate}))

    let tdsOptions = [
        { tdsSectionId: 1, tdsSection: 'No TDS', displayTDSSection: 'No TDS | 0%', tdsValue: 0 },
        { tdsSectionId: 2, tdsSection: '194J', displayTDSSection: '194J | 10%', tdsValue: 10 },
        { tdsSectionId: 3, tdsSection: '194C', displayTDSSection: '194C | 1%', tdsValue: 1 },
        { tdsSectionId: 4, tdsSection: '194Q', displayTDSSection: '194Q | 0.1%', tdsValue: 0.1 },
        { tdsSectionId: 5, tdsSection: 'Other', displayTDSSection: 'Other', tdsValue: null },
    ]

    const handleTDSSelection = (e) => {
        const updatedDisplaySellerPOItems = allDisplaySellerPOItems.map(eachDisplaySellerPOItem => {
            const relatedTDSOption = updatedTDSOptions.find(eachTDS => eachTDS.tdsSectionId === e.target.value)

            if (eachDisplaySellerPOItem.displaySellerPOItemId === displaySellerPOItem.displaySellerPOItemId) {
                return { ...eachDisplaySellerPOItem, tdsSection: relatedTDSOption.tdsSection, tdsSectionId: e.target.value, tdsValue: relatedTDSOption.tdsValue }
            }
            return eachDisplaySellerPOItem
        })
        const { sellerPO, sellerPOItems } = calculateSellerPO(displaySellerPO, updatedDisplaySellerPOItems)

        setDisplaySellerPOItems(sellerPOItems)
    }

    const handleTDSValueChange = (e) => {
        const updatedDisplaySellerPOItems = allDisplaySellerPOItems.map(eachDisplaySellerPOItem => {

            if (eachDisplaySellerPOItem.displaySellerPOItemId === displaySellerPOItem.displaySellerPOItemId) {
                return { ...eachDisplaySellerPOItem, tdsValue: e.target.value, tdsSection: 'Other' }
            }
            return eachDisplaySellerPOItem
        })
        const { sellerPO, sellerPOItems } = calculateSellerPO(displaySellerPO, updatedDisplaySellerPOItems)

        setDisplaySellerPOItems(sellerPOItems)
    }

    const handleOtherTDSCharge = (e) => {

        if (parseFloat(e.target.value) > 30) {
            e.target.value = 30
            dispatch(raiseToast({ severity: 'warn', detail: 'TDS can\'t be more than 30', life: 3000 }))
        }

        const updatedDisplaySellerPOItems = allDisplaySellerPOItems.map(eachDisplaySellerPOItem => {
            if (eachDisplaySellerPOItem.displaySellerPOItemId === displaySellerPOItem.displaySellerPOItemId) {
                return { ...eachDisplaySellerPOItem, tdsValue: e.target.value }
            }
            return eachDisplaySellerPOItem
        })

        const { sellerPO, sellerPOItems } = calculateSellerPO(displaySellerPO, updatedDisplaySellerPOItems)
        setDisplaySellerPOItems(sellerPOItems)
    }

    const handleDisplaySellerPOItems = (e) => {
        const updatedDisplaySellerPOItems = allDisplaySellerPOItems.map(eachDisplaySellerPOItem => {
            if (eachDisplaySellerPOItem.displaySellerPOItemId === displaySellerPOItem.displaySellerPOItemId) {
                return { ...eachDisplaySellerPOItem, [e.target.name]: e.target.value }
            }
            return eachDisplaySellerPOItem
        })

        setDisplaySellerPOItems(updatedDisplaySellerPOItems)
    }

    const handleAddRemarksClick = () => {
        const updatedDisplaySellerPOItems = allDisplaySellerPOItems.map(eachDisplaySellerPOItem => {
            if (eachDisplaySellerPOItem.displaySellerPOItemId === displaySellerPOItem.displaySellerPOItemId) {
                return { ...eachDisplaySellerPOItem, displayRemarks: true }
            }
            return eachDisplaySellerPOItem
        })

        setDisplaySellerPOItems(updatedDisplaySellerPOItems)
    }

    const handleCancelRemarks = () => {
        const updatedDisplaySellerPOItems = allDisplaySellerPOItems.map(eachDisplaySellerPOItem => {
            if (eachDisplaySellerPOItem.displaySellerPOItemId === displaySellerPOItem.displaySellerPOItemId) {
                return { ...eachDisplaySellerPOItem, displayRemarks: false, remarks: null }
            }
            return eachDisplaySellerPOItem
        })

        setDisplaySellerPOItems(updatedDisplaySellerPOItems)
    }

    let updatedTDSOptions = []
    if (relatedSellerCompanyDetails?.tdsSection194q) {
        updatedTDSOptions = [tdsOptions[3]]
    } else {
        if (relatedSellerCompanyDetails?.panCode?.[3] === "P") {

            if (displaySellerPOItem?.HSNCode?.slice?.(0, 2) === "99") {
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            } else {
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        } else {
            tdsOptions = tdsOptions?.map(eachOpt => {
                if (eachOpt.tdsSection === "194C") {
                    return { ...eachOpt, displayTDSSection: '194C | 2%', tdsValue: 2 }
                }
                return eachOpt
            })

            if (displaySellerPOItem?.HSNCode?.slice?.(0, 2) === "99") {
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            } else {
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        }
    }

    let relatedBrand = {}
    if (materialDetails && brandData.length){
        relatedBrand = brandData.find(eachBrand => eachBrand.brandId === materialDetails.brandId)
    }

    const relatedBuyerQuoteItems = buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerReqItemId === displaySellerPOItem?.buyerReqItemId && eachBuyerQuoteItem?.statusId === 1 && eachBuyerQuoteItem?.totReqQty > 0)
    let totalSellerQuotPrice = 0
    relatedBuyerQuoteItems?.map(eachBuyerQuoteItem => {
        totalSellerQuotPrice += parseFloat(eachBuyerQuoteItem?.bQuotSellerPrice)
    })
    let avgSellerQuotPrice = round(totalSellerQuotPrice / (relatedBuyerQuoteItems?.length))

    const variationPercent = ((displaySellerPOItem.unitPrice - avgSellerQuotPrice) / avgSellerQuotPrice) * 100

    let today = moment()
    const monthsSinceSellerRequestItemCreated = today.diff(sellerReqItem.createdAt, 'months')

    let isPriceExceedAvgSellerPrice = ((variationPercent > 1 || monthsSinceSellerRequestItemCreated > 6) && displaySellerPO?.companyId !== displaySellerPO?.pmCompanyId) ? true : false

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed

    return (
        <div key={`displaySellerPOItem-${displaySellerPOItem.displaySellerPOItemId}`}>
            <div className="flex flex-row">
            <p className="mr-2 mt-0" >
                <span className={`font-semibold text-xs`} >
                    {materialDetails.materialId}</span> &nbsp;| {getProductName(relatedBrand.brandName, materialDetails.productName, relatedBrand.variantName)} | {getProductSpecification(materialDetails.productSpecification)}
            </p>
            {
                isPriceExceedAvgSellerPrice ?
                <>
                    <div className={`flex flex-column mx-1 custom-tool-tip-${displaySellerPOItem.materialId}`} style={{ width: "2%", color: 'red'}}>
                        <i className="pi pi-info-circle quote-gst-icon ml-1"></i>
                    </div>
                    <Tooltip target={`.custom-tool-tip-${displaySellerPOItem?.materialId}`} position="top" autoHide>
                        <p className="m-0">Approval will be needed as unit price exceeds average seller unit price.</p>
                    </Tooltip>
                </> : 
                null
            }
            </div>
            <div className="grid mb-2 align-items-center">
                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                    <TextInputField name="qty" value={displaySellerPOItem.qty} labelText='Q.Qty' disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pl-0">
                    <TextInputField name="leadTime" value={displaySellerPOItem.leadTime} labelText='Q.LeadTime' disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pl-0">
                    <TextInputField name="quotUnitPrice" value={displaySellerPOItem.unitPrice} labelText='Q.UnitPrice' disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pl-0">
                    <TextInputField name="quotDiscountRate" value={displaySellerPOItem.quotDiscountRate} labelText='Q.Disc' disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pl-0">
                    <DropDownField name="GSTRate" options={gstOptions} value={displaySellerPOItem.GSTRate} labelText={`Q.${pmCompanyConfig.GSTRateLabel}`} optionLabel="label" optionValue="value" disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pl-0">
                    <TextInputField name="quotTotalAmountBeforeTax" value={displaySellerPOItem.itemAmountBeforeTax} labelText='Before Tax' disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pl-0">
                    <TextInputField name="quotTotalAmountWithTax" value={displaySellerPOItem.itemAmountWithTax} labelText='After Tax' disabled />
                </div>
                {
                    isHSNEntryAllowed ? 
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 pl-0">
                        <TextInputField name="HSNCode" value={displaySellerPOItem.HSNCode} labelText='Q.HSN' onChange={handleDisplaySellerPOItems} />
                    </div>
                    :
                    null
                }
                {
                    pmCompanyConfig.isTDSAutomated ? 
                    null
                    :
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                        <TextInputField name="tdsValue" value={displaySellerPOItem.tdsValue} labelText='TDS Value' keyfilter={"num"} onChange={(e) => handleTDSValueChange(e)}/>
                    </div>
                }
                {/* <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 w-6rem">
                    <DropDownField name="tdsSection" options={updatedTDSOptions} value={displaySellerPOItem.tdsSectionId} optionLabel="displayTDSSection" optionValue="tdsSectionId" labelText="Select TDS(%)" errorBorder={!displaySellerPOItem.tdsSectionId} onChange={handleTDSSelection} />
                </div>
                {displaySellerPOItem.tdsSectionId === 5 &&
                    <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                        <TextInputField name="otherTDSAmount" value={displaySellerPOItem.tdsValue} labelText='Other(%)' onChange={handleOtherTDSCharge} keyfilter="num" errorBorder={!displaySellerPOItem.tdsValue} />
                    </div>
                } */}
                {
                    displaySellerPOItem.displayRemarks ?
                        <div className="w-8 ml-2 flex relative mt-1">
                            <TextAreaField name="materialSpecRemark" maxLength={1000} rows={2} cols={2} value={displaySellerPOItem.materialSpecRemark} onChange={handleDisplaySellerPOItems} />
                            <Button icon="pi pi-times" className="absolute" style={{ right: '-1.1rem', top: '-0.8rem', height: '1rem', width: '1.5rem' }} rounded text severity="danger" onClick={handleCancelRemarks} />
                        </div> :
                        <div className="flex align-items-end">
                            <Button label='Add Remarks' className='h-2rem p-2' onClick={handleAddRemarksClick} text />
                        </div>
                }
            </div>
            <div></div>
        </div>
    )
}


export default DisplaySellerPOItem